<template>
  <div class="home-container page">
    <div class="home-top-bar">
      <div class="brand-wrap">
        <span class="brand-emoji">💋</span>
          <span class="home-app-name">{{ $t("home.brand_name") }}</span>
      </div>
      <img
        src="/img/eharmony-home/ico.png"
        class="top-bar-icon"
        :alt="$t('home.menu_alt')"
        @click="goToMine"
      />
    </div>

    <div class="home-scroll">
      <div class="home-top-section">
        <div class="banner">
          <van-swipe
            v-if="displayBanners.length"
            class="my-swipe"
            :autoplay="3000"
            indicator-color="#fff"
          >
            <van-swipe-item v-for="(banner, index) in displayBanners" :key="index">
              <img :src="banner" class="banner-img" :alt="$t('home.banner_alt')" />
            </van-swipe-item>
          </van-swipe>
        </div>

        <div class="notice-bar">
          <van-icon name="volume-o" class="notice-icon" />
          <div class="notice-wrapper">
            <div class="notice-text">{{ displayNotice }}</div>
          </div>
        </div>

        <div class="hot-game">
          <div
            v-for="item in featureItems"
          :key="item.path || item.action || item.icon"
            class="hot-game-li"
            @click="goFeature(item)"
          >
          <img :src="item.icon" :alt="$t('home.feature_alt')" />
          </div>
        </div>
      </div>

      <div class="home-body">
        <div class="section-title">{{ $t("home.popular_advice") }}</div>

        <div
          v-for="(item, index) in displayProfiles"
          :key="item.id || index"
          class="profile-card"
          @click="toDetail(item.id)"
        >
          <div v-if="item.image" class="card-image">
            <img :src="item.image" :alt="item.code" />
          </div>

          <div class="card-content">
            <div class="card-top-line">
              <div class="chip-group">
                <div class="meta-chip">{{ $t("home.certification") }}</div>
                <div class="meta-chip">{{ $t("home.video_authentication") }}</div>
              </div>
              <div v-if="item.code" class="profile-code">{{ item.code }}</div>
            </div>

            <div v-if="item.tags.length" class="tags-container">
              <div
                v-for="(tag, tagIndex) in item.tags"
                :key="`${item.id}-${tagIndex}`"
                class="tag-item"
                :class="tagClass(tagIndex)"
              >
                {{ tag }}
              </div>
            </div>

            <div v-if="item.vote" class="vote-line">
              {{ $t("home.voting_competition") }}:
              <span class="movie-list-money">{{ item.vote }}</span>
            </div>

            <div v-if="item.description" class="profile-desc">{{ item.description }}</div>

            <div class="card-button">{{ $t("home.want_to_date_her") }}</div>
          </div>
        </div>
      </div>
    </div>

    <van-popup
      v-model="showVipDialog"
      get-container="body"
      class="vip-popup"
      round
      close-on-click-overlay
      :lock-scroll="false"
    >
      <div class="vip-dialog-content">
        <div class="vip-dialog-title">{{ $t("home.vip_explanation_title") }}</div>
        <div class="vip-dialog-text">{{ $t("home.vip_explanation_text") }}</div>
        <button type="button" class="vip-confirm-btn" @click="showVipDialog = false">
          {{ $t("home.confirm") }}
        </button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { normalizeMediaUrl } from "../../utils/media";

export default {
  data() {
    return {
      notice: "",
      hasToken: false,
      basicData: [],
      datalist: [],
      banners: [],
      showVipDialog: false,
    };
  },
  computed: {
    displayNotice() {
      return (
        this.notice ||
        this.$t("home.default_notice")
      );
    },
    displayBanners() {
      return (this.banners || [])
        .map((item) => normalizeMediaUrl(item && item.url))
        .filter(Boolean);
    },
    featureItems() {
      return [
        {
          icon: "/img/eharmony-home/duihuan.png",
          path: "/Recharge",
          requiresAuth: true,
        },
        {
          icon: "/img/eharmony-home/notice.png",
          path: "/ServiceOnline",
          requiresAuth: false,
        },
        {
          icon: "/img/eharmony-home/like_active.png",
          path: "/GameN",
          requiresAuth: false,
        },
        {
          icon: "/img/eharmony-home/vip.png",
          action: "vip-dialog",
          requiresAuth: false,
        },
      ];
    },
    displayProfiles() {
      return this.datalist.slice(0, 8).map((item, index) => this.normalizeProfile(item, index));
    },
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data || [];
        this.notice = this.basicData.notice || "";
        this.banners = this.basicData.banners || [];
      });
    },
    goFeature(item) {
      if (item.action === "vip-dialog") {
        this.showVipDialog = true;
        return;
      }

      if (item.requiresAuth && !this.hasToken) {
        this.$router.push({ path: "/Login" });
        return;
      }

      this.$router.push({ path: item.path });
    },
    goToMine() {
      this.$router.push({ path: this.hasToken ? "/Mine" : "/Login" });
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id } });
    },
    checkToken() {
      this.hasToken = !!localStorage.getItem("token");
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist1",
        data: { id: 0, page: 1 },
      }).then((res) => {
        const lang = this.$t("auth.lang");
        this.datalist = (res.data || []).map((item) => {
          const parts = String(item.flag || "").split("|");
          const localizedFlag =
            lang === "zh"
              ? parts[0]
              : lang === "en"
              ? parts[1]
              : lang === "ja"
              ? parts[2]
              : parts[3];

          return {
            ...item,
            flagArray: String(localizedFlag || "")
              .split(/[，,]/)
              .map((tag) => tag.trim())
              .filter(Boolean),
          };
        });
      });
    },
    normalizeProfile(item, index) {
      const tags = (item.flagArray && item.flagArray.length ? item.flagArray : []).slice(
        0,
        5
      );

      return {
        id: item.id || index + 1,
        image: normalizeMediaUrl(item.img_url),
        code: this.buildCode(item),
        tags,
        vote: this.buildVote(item, index),
        description: this.buildDescription(item),
      };
    },
    buildCode(item) {
      return String(item.code || "").trim();
    },
    buildVote(item, index) {
      const numericValue =
        Number(item.price || item.score || item.id || 0) || (index + 1) * 100;

      return item.vote || (item.price || item.score ? numericValue : "");
    },
    buildDescription(item) {
      const parts = [];
      const height = Number(item.height || 0);
      const round = Number(item.round || 0);
      const city = String(item.class_name || "").trim();

      if (height) {
        parts.push(`${this.$t("home.height")}:${height}cm`);
      }

      if (round) {
        parts.push(`${this.$t("home.round")}: ${round}`);
      }

      if (city) {
        parts.push(`${this.$t("home.serving_city")}:${city}`);
      }

      return parts.join(" ");
    },
    tagClass(index) {
      const classNames = ["red-label", "yellow-label", "blue-label"];
      return classNames[index % classNames.length];
    },
  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
  },
};
</script>

<style lang="less" scoped>
.home-container {
  min-height: 100%;
  background: #fff;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.home-container::-webkit-scrollbar {
  display: none;
}

.home-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 36px 20px;
  background: #fff;
}

.brand-wrap {
  display: flex;
  align-items: center;
}

.brand-emoji {
  margin-right: 16px;
  font-size: 68px;
  line-height: 1;
}

.home-app-name {
  color: #5661dc;
  font-size: 48px;
  font-weight: 700;
  line-height: 64px;
}

.top-bar-icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.home-scroll {
  padding: 20px 32px 160px;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.home-scroll::-webkit-scrollbar {
  display: none;
}

.home-top-section {
  margin: -20px -32px 0;
  padding: 20px 32px 24px;
  background: #f3f3f3;
}

.banner {
  margin-bottom: 24px;
}

.my-swipe {
  border-radius: 0;
  overflow: hidden;
}

.banner-img {
  display: block;
  width: 100%;
  height: 284px;
  object-fit: cover;
}

.notice-bar {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 20px 24px;
  background: #fff;
  border: 2px solid #ececec;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.notice-icon {
  margin-right: 20px;
  color: #636aea;
  font-size: 56px;
}

.notice-wrapper {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
}

.notice-text {
  display: inline-block;
  color: #6667df;
  font-size: 28px;
  line-height: 48px;
  padding-left: 100%;
  animation: marquee 30s linear infinite;
}

.hot-game {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: stretch;
  margin-bottom: 24px;
  background: #fff;
  border: 2px solid #ececec;
}

.hot-game-li {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 128px;
  position: relative;
}

.hot-game-li:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 28px;
  right: 0;
  width: 2px;
  height: 72px;
  background: #ececec;
}

.hot-game-li img {
  width: 44px;
  height: 44px;
  object-fit: contain;
}

.home-body {
  background: #fff;
  border: 2px solid #ececec;
}

.section-title {
  padding: 28px 24px 16px;
  color: #1f1f1f;
  font-size: 32px;
  line-height: 48px;
}

.profile-card {
  display: flex;
  padding: 24px;
}

.card-image {
  flex: 0 0 110px;
  width: 110px;
  height: 110px;
  margin-right: 18px;
  overflow: hidden;
}

.card-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-content {
  flex: 1;
  min-width: 0;
}

.card-top-line {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.chip-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.meta-chip {
  padding: 4px 10px;
  border-radius: 6px;
  background: linear-gradient(180deg, #f7ead0 0%, #fff6e9 100%);
  color: #a67f50;
  font-size: 16px;
  line-height: 24px;
}

.profile-code {
  margin-left: 12px;
  color: #303030;
  font-size: 18px;
  line-height: 24px;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.tag-item {
  padding: 8px 14px;
  border-radius: 4px;
  color: #fff;
  font-size: 18px;
  line-height: 26px;
}

.red-label {
  background: #ff2f8b;
}

.yellow-label {
  background: #ff9831;
}

.blue-label {
  background: #18a1ff;
}

.vote-line {
  color: #333;
  font-size: 18px;
  line-height: 28px;
}

.movie-list-money {
  color: #0c73ff;
  font-weight: 700;
}

.profile-desc {
  margin-top: 4px;
  color: #666;
  font-size: 18px;
  line-height: 26px;
}

.card-button {
  margin-top: 12px;
  height: 48px;
  border-radius: 6px;
  background: linear-gradient(90deg, #e83db6 0%, #672ac8 100%);
  color: #fff;
  font-size: 20px;
  line-height: 48px;
  font-weight: 700;
  text-align: center;
}

.vip-popup {
  width: 500px;
  max-width: calc(100vw - 96px);
  overflow: hidden;
  border-radius: 28px;
}

.vip-dialog-content {
  padding: 40px 42px 30px;
  background: #fff;
  text-align: center;
}

.vip-dialog-title {
  color: #2d2d2d;
  font-size: 34px;
  line-height: 48px;
  font-weight: 700;
}

.vip-dialog-text {
  margin-top: 26px;
  color: #4a4a4a;
  font-size: 24px;
  line-height: 38px;
}

.vip-confirm-btn {
  display: block;
  width: 100%;
  height: 64px;
  margin-top: 34px;
  border: 0;
  border-radius: 32px;
  background: linear-gradient(90deg, #ff6f3c 0%, #ff0048 100%);
  color: #fff;
  font-size: 26px;
  line-height: 64px;
  font-weight: 700;
}

::v-deep .van-overlay {
  background: rgba(0, 0, 0, 0.55);
}

::v-deep .van-popup--center {
  margin-top: -20px;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>

<style lang="less">
html,
body,
#app {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar,
#app::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
</style>
